import CourseSearchResults from './course-search-results'
import CourseSearchResultsQuery, { QUERY_CITY_SEARCH } from './course-search-results.query'

export { CourseSearchResultsQuery, QUERY_CITY_SEARCH }

export default CourseSearchResults
